import { render } from "./FamilyConfig.vue?vue&type=template&id=502df81d"
import script from "./FamilyConfig.vue?vue&type=script&lang=js"
export * from "./FamilyConfig.vue?vue&type=script&lang=js"

import "./FamilyConfig.vue?vue&type=style&index=0&id=502df81d&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__